import { useEffect } from "react";
import { useAuthStore } from "./auth.store";
import { refreshSession } from "../lib/api";

/** Attempts a silent token refresh on first mount, then sets `ready`. */
export function AuthBootstrap() {
  const setReady = useAuthStore((s) => s.setReady);
  const ready = useAuthStore((s) => s.ready);

  useEffect(() => {
    if (ready) return;
    let cancelled = false;
    (async () => {
      try {
        await refreshSession();
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [ready, setReady]);

  return null;
}
